<template lang="pug">
.s-space
  .space-title(:style="{'padding-top':sysInfo.statusBarHeight+'px','line-height':sysInfo.titleBarHeight+'px'}") AR奇妙探险GO
  .move#move 
    .sticker-list 
      .item(v-for="(task, j) in taskMap" :key="j", :class="'sticker-box-item-' + task.position" @click="clickItem(task,j,list)")
        TaskImage(:flag="getTaskImage(task, j, list)")
  .status
    .flex-between 
      .progress 
        .inner(:style="{width: list.length*20+'%'}")
      .btn(@click="viewPhoto()" v-if="list.length < min && !spaceMonsterPhoto && completed==2") 预览
      .btn(@click="compositePicture()" v-if="list.length >= min && !spaceMonsterPhoto && completed==2") 获取合照
      .btn(@click="view()" v-if="spaceMonsterPhoto && completed==2") 查看合照
  .reload(@click="reload()")    
  .pop(v-if="show" @click.self="show = false")   
    .content 
      .btn(@click="jumpScan") 
  .downloadbox(v-show="showDownload" @click.self="showDownload = false")       
    .flex 
      .title(:class="spaceMonsterPhoto?'photo':''")
      #download
      .btn(@click="savePhoto()" v-if="spaceMonsterPhoto") 
    //- 盲盒
  .blindboxicon(@click="onShowBlindbox()" :class="list.length >= min?'on':''")   
  .welcomeBox(v-if="showBlindbox")
    Blindbox(@close="onHideBlindbox", :qrcode="footprintQrcode.qrCode")

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import TaskImage from '@/components/space/TaskImage'
import html2canvas from 'html2canvas'
import { getSpaceMonsterPhoto, postSpaceMonsterPhoto } from '@/api/index'
import AlipayService from '@/services/AlipayService'
import Blindbox from '@/components/footprint/Blindbox2'
export default {
  name: 'Sticker',
  components: { TaskImage, Blindbox },
  props: {},
  data() {
    return {
      show: false,
      taskMap: {
        task1: {
          id: 'QianXiXiMonster',
          position: '1',
          image: 'monster-1',
          imageGray: 'monster-gray-1',
        },
        task2: {
          id: 'QianQianMianMonster',
          position: '2',
          image: 'monster-2',
          imageGray: 'monster-gray-2',
        },
        task3: {
          id: 'JinTunTunMonster',
          position: '3',
          image: 'monster-3',
          imageGray: 'monster-gray-3',
        },
        task4: {
          id: 'DaYanZaiMonster',
          position: '4',
          image: 'monster-4',
          imageGray: 'monster-gray-4',
        },
        task5: {
          id: 3,
          position: '5',
          image: 'venue-1',
          imageGray: 'venue-gray-1',
        },
        task6: {
          id: 10,
          position: '6',
          image: 'venue-2',
          imageGray: 'venue-gray-2',
        },
        task7: {
          id: 11,
          position: '7',
          image: 'venue-3',
          imageGray: 'venue-gray-3',
        },
        task8: {
          id: 5,
          position: '8',
          image: 'venue-4',
          imageGray: 'venue-gray-4',
        },
      },
      monsterTask: [],
      venueTask: [],
      base64: [],
      spaceMonsterPhoto: null,
      data: [
        {
          id: 'QianXiXiMonster',
          x: 0,
          y: 94,
          width: 197,
          height: 285,
          url: require('@/assets/space/m1.png'),
        },
        {
          id: 'QianQianMianMonster',
          x: 971,
          y: 319,
          width: 225,
          height: 306,
          url: require('@/assets/space/m2.png'),
        },
        {
          id: 'JinTunTunMonster',
          x: 927,
          y: 0,
          width: 279,
          height: 268,
          url: require('@/assets/space/m3.png'),
        },
        {
          id: 'DaYanZaiMonster',
          x: 0,
          y: 440,
          width: 277,
          height: 277,
          url: require('@/assets/space/m4.png'),
        },
      ],
      showDownload: false,
      masterMap: [],
      completed: 0,
      min: 5,
      showBlindbox: false,
    }
  },
  // watch: {
  //   list: function() {
  //     if (this.list.length >= 2) {
  //       getSpaceMonsterPhoto({ userId: this.user.id }).then((res) => {
  //         if (res) {
  //           this.spaceMonsterPhoto = res.url
  //         }
  //       })
  //     }
  //   },
  // },
  computed: {
    ...mapState('app', ['sysInfo', 'router', 'user', 'footprintQrcode']),
    list() {
      let taskListAll = [...this.monsterTask, ...this.venueTask]
      taskListAll.map((item) => {
        if (!item.id) {
          item.id = item.monsterCode
        }
      })
      return taskListAll
    },
  },
  methods: {
    ...mapMutations('app', ['setPending']),
    ...mapActions('app',
      [
        'GetSpaceTaskListAll',
        'GetFootprintTaskListToday',
        'GetFootprintServiceTime','GetFootprintCreateQRCodeStr']
    ),
    onBack() {
      this.$router.replace(this.router.back)
    },
    getTaskImage(task, key, list) {
      if (list) {
        const cur = list.filter((item) => item.id == task.id)
        return cur.length ? task.image : task.imageGray
      }
      return task.imageGray
    },
    fetchSpaceTaskListAll() {
      this.completed = 0
      // alert('开始获取展项、怪兽接口数据')

      this.setPending(true)
      // this.user.accessToken   'authbseBd941f6fd038949bf950ce5f11f8f2X22'
      this.GetSpaceTaskListAll({ token: this.user.accessToken })
        .then((res) => {
          console.log(res.data.data)
          const owned = res.data.data.sSpaceMonsterList.filter(
            (item) => {
              return item.monsterDetail && item.monsterDetail.status == 'OWNED'
            }
          )
          console.log(res)
          this.masterMap = res.data.data.sSpaceMonsterList
          console.log(this.masterMap)
          this.monsterTask = owned
          this.setPending(false)
          this.completed = this.completed + 1
          console.log(this.completed)
          // alert('怪兽接口数据获取成功')
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
          // alert('怪兽接口数据获取失败'+err)
        })

      this.GetFootprintTaskListToday({ userId: this.user.id })
        .then((res) => {
          console.log(res.masterTask)
          this.venueTask = res.masterTask
          this.setPending(false)
          this.completed = this.completed + 1
          console.log(this.completed)
          // alert('展项接口数据获取成功')
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
          // alert('展项接口数据获取失败'+ err)
        })

        getSpaceMonsterPhoto({ userId: this.user.id }).then((res) => {
          if (res) {
            this.spaceMonsterPhoto = res.url
          }
        })



      // this.setPending(false)
      // this.completed=2
      
      // this.monsterTask = [
      // {
      //   "jumpUrl": "点击风险怪兽跳到蚂蚁探险链接",
      //   "monsterCode": "JinTunTunMonster",

      // },
      // {
      //   "jumpUrl": "点击风险怪兽跳到蚂蚁探险链接",
      //   "monsterCode": "QianXiXiMonster",

      // },
      // ]
      // this.venueTask = [
      //       {
      //           "seqId": 10001,    // 序号，本次请求的数据列表唯一只。
      //           "id": 3,           // 活动支线任务(一级)id,对应活动支线任务(一级)名称，唯一值。
      //           "name": "飞跃蚂蚁森林", // 活动支线任务名称
      //           "stampImagesPath": "4.png",  // 图章图片地址，相对路径。
      //           "createdTime": "2021-10-15"  // 参与活动任务日期
      //       },
      //       {
      //           "seqId": 10001,    // 序号，本次请求的数据列表唯一只。
      //           "id": 5,           // 活动支线任务(一级)id,对应活动支线任务(一级)名称，唯一值。
      //           "name": "飞跃蚂蚁森林", // 活动支线任务名称
      //           "stampImagesPath": "4.png",  // 图章图片地址，相对路径。
      //           "createdTime": "2021-10-15"  // 参与活动任务日期
      //       },
      //       {
      //           "seqId": 10001,    // 序号，本次请求的数据列表唯一只。
      //           "id": 10,           // 活动支线任务(一级)id,对应活动支线任务(一级)名称，唯一值。
      //           "name": "飞跃蚂蚁森林", // 活动支线任务名称
      //           "stampImagesPath": "4.png",  // 图章图片地址，相对路径。
      //           "createdTime": "2021-10-15"  // 参与活动任务日期
      //       },
      // ]
    },
    onShare() {
      this.$nextTick(() => {
        html2canvas(document.getElementById('welcome')).then((canvas) => {
          const dataURL = canvas.toDataURL('image/png')
          this.imgUrl = dataURL
        })
      })
    },
    compositePicture(readonly) {
      const that = this
      this.draw(function() {
        document.getElementById('download').innerHTML =
          '<img style="width:100%" src="' + that.base64[0] + '">'
        let base64 = that.base64[0].replace('data:image/png;base64,', '')
        let data = new FormData()
        data.append('base64Data', base64)
        data.append('userId', that.user.id)
        // 生成合照
        postSpaceMonsterPhoto(data).then((res) => {
 
          that.spaceMonsterPhoto = res.url
          that.setPending(false)
          that.showDownload = true
        })
      })
    },
    draw(fn) {
      let data
      if (fn == 'view') {
        data = Object.assign([], this.data)
      } else {
        data = Object.assign([], this.data)
        data = data.filter((item) => this.list.filter(inside => inside.id==item.id).length)
      }
      var c = document.createElement('canvas'),
        ctx = c.getContext('2d'),
        len = data.length
      c.width = 1200
      c.height = 720
      ctx.rect(0, 0, c.width, c.height)
      var bg = new Image()
      bg.src = require('@/assets/space/bg.png')
      bg.onload = function() {
			  ctx.drawImage(bg, 0, 0, 1200, 720)
        drawing(0)
			}
      const that = this
      function drawing(n) {
        if (n < len) {
          var img = new Image()
          //img.crossOrigin = 'Anonymous'; //解决跨域
          img.src = data[n].url
          img.onload = function() {
            ctx.drawImage(img, data[n].x, data[n].y, data[n].width, data[n].height)
            drawing(n + 1)
          }
        } else {
          var img = new Image()
          img.src = require('@/assets/space/border.png')
          img.onload = function() {
            ctx.drawImage(img, 0, 0, 1200, 720)
            ctx.fillStyle = '#6b5cfc'
            ctx.font = '24px '
            ctx.fillText(`支付宝空间站 ${that.date}`, 842, 668)
            
            if (fn == 'view') {
              that.showDownload = true
              var box = document.getElementById('download')
              document.getElementById('download').innerHTML = ''
              box.appendChild(c)
            } else {
              that.setPending(true)
              that.base64.push(c.toDataURL('image/png'))
              fn()
            }
          }
        }
      }
    },
    view() {
      document.getElementById('download').innerHTML =
        '<img style="width:100%" src="' + this.spaceMonsterPhoto + '">'
      this.showDownload = true
    },
    viewPhoto() {
      this.draw('view')
    },
    clickItem(task, key, list) {
      if(this.completed<2){
        console.log('接口未返回数据')
        return false
      }
      console.log(task)
      const cur = list.filter((item) => item.id == task.id)
      if (typeof task.id === 'number') {
        this.show = true
      } else {
        const jumpItem = this.masterMap.filter((item) => item.monsterCode == task.id)
        if (!jumpItem.length) {
          // alert('尚未配置,无法跳转')
          return false
        } else {
          // alert(jumpItem[0].jumpUrl.split('&')[1].replace('page=', ''))
          let url = jumpItem[0].jumpUrl.split('&')[1].replace('page=', '')
          AlipayService.sendEvent(AlipayService.Events.JUMP_URL, `${url}?monsterCode=${jumpItem[0].monsterCode}`)
        } 
      }
    },
    jumpScan() {
      AlipayService.sendEvent(AlipayService.Events.SCAN)
    },
    savePhoto() {
      AlipayService.sendEvent(AlipayService.Events.SAVE_IMAGE, {
        url: this.spaceMonsterPhoto,
      })
    },
    onMessage(e) {
      if(e.msg == 'backSpace'){
        this.fetchSpaceTaskListAll()
      }
    },
    reload() {
      this.fetchSpaceTaskListAll()
    },
    onShowBlindbox() {
      if(this.list.length < this.min){
        return false
      }
      this.showBlindbox = true;
      if (!this.footprintQrcode.qrCode) {
        this.fetchFootprintCreateQRCodeStr();
      }
    },
    onHideBlindbox() {
      this.showBlindbox = false;
    },
    fetchFootprintCreateQRCodeStr() {
      this.setPending(true)
      this.GetFootprintCreateQRCodeStr({ userId: this.user.id })
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },
  },
  created() {
    this.fetchSpaceTaskListAll()
    this.GetFootprintServiceTime({ format: 'yyyy-MM-dd HH:mm:ss' }).then( (res) => {
      this.date = res.data.split(' ')[0].replaceAll('-','.')
    })

  },
  mounted() {
    AlipayService.on(AlipayService.Events.ONMESSAGE, this.onMessage)
    var winHeight = window.innerHeight
    var winWidth = window.innerWidth
    var y = (winWidth * 1.5 * 2.13333 - winHeight) / 2
    var x = (winWidth * 1.5 - winWidth) / 2
    document.getElementById('move').style.width = winWidth * 1.5 + 'px'
    document.getElementById('move').style.height =
      winWidth * 1.5 * 2.13333 + 'px'
    document.getElementById('move').style.top = -y + 'px'
    var startX = 0
    var startY = 0
    var endX = 0
    var endY = 0
    var disX = 0
    var disY = 0
    var left = 0
    var top = 0
    var first = false
    var that = this
    document.addEventListener(
      'touchstart',
      function(event) {
        if(that.showBlindbox){
          return false
        }
        var touch = event.targetTouches[0]
        startX = touch.pageX - disX
        startY = touch.pageY - disY
        if (!first) {
          startX = startX + x
          startY = startY + y
        }
      },
      false
    )

    document.addEventListener(
      'touchmove',
      function(event) {
        if(that.showBlindbox){
          return false
        }
        first = true
        var touch = event.targetTouches[0]
        endX = touch.pageX
        endY = touch.pageY
        left = endX - startX
        top = endY - startY
        if (left > 0) {
          left = 0
        } else if (left + x < -x) {
          left = -x * 2
        }
        if (top > 0) {
          top = 0
        } else if (top + y < -y) {
          top = -y * 2
        }
        document.getElementById('move').style.left = left + 'px'
        document.getElementById('move').style.top = top + 'px'
      },
      false
    )
    document.addEventListener(
      'touchend',
      function() {
        if(that.showBlindbox){
          return false
        }
        disX = left
        disY = top
      },
      false
    )
    console.log(this.sysInfo)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/space"
.s-space
  overflow: hidden
  width: 100%
  height: 100%
  position: relative
  .move
    background: url("~assets/space/map.jpg") center center no-repeat
    background-size: cover
    position: absolute
    left: -25%
    .sticker-list
      .sticker-box-item
        position: absolute
        img
          +image
        &-1
          top: 32.5%
          left: 40%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute
        &-2
          top: 42.5%
          left: 24.5%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute
        &-3
          top: 63.5%
          left: 35.5%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute
        &-4
          top: 70%
          left: 73%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute
        &-5
          top: 57%
          left: 62%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute
        &-6
          top: 52%
          left: 25%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute
        &-7
          top: 34%
          left: 14%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute
        &-8
          top: 32%
          left: 71%
          width: pxRes(60 * 1.5)
          height: pxRes(60 * 1.5)
          position: absolute

  .status
    background: url("~assets/space/progress.png") center center no-repeat
    background-size: cover
    width: pxRes(163 * 1.5)
    height: pxRes(60 * 1.5)
    position: absolute
    top: pxRes(64 * 1.5)
    left: 0
    .flex-between
      display: flex
      justify-content: space-between
      align-items: center
      padding: pxRes(35 * 1.5) pxRes(8 * 1.5) 0 pxRes(12 * 1.5)
      .progress
        background: #fff
        border-radius: pxRes(7 * 1.5)
        width: pxRes(88 * 1.5)
        height: pxRes(7 * 1.5)
        padding: pxRes(1 * 1.5)
        .inner
          background: #1e66ed
          width: 20%
          height: 100%
          border-radius: pxRes(5 * 1.5)
      .btn
        background: #fff
        color: #1e66ed
        width: pxRes(50 * 1.5)
        height: pxRes(16 * 1.5)
        border-radius: pxRes(10 * 1.5)
        font-size: pxRes(9 * 1.5)
        line-height: pxRes(16 * 1.5)
        text-align: center
  .reload
    background: url("~assets/space/reload.png") center center no-repeat
    background-size: cover
    width: pxRes(15.5 * 1.5)
    height: pxRes(15.5 * 1.5)
    position: absolute
    top: pxRes(89 * 1.5)
    left: pxRes(170 * 1.5)      
  .downloadbox
    position: fixed
    top: 0
    width: 100%
    left: 0
    height: 100%
    display: -webkit-box
    display: -ms-flexbox
    display: flex
    background: rgba(0, 0, 0, 0.7)
    z-index: 999
    align-items: center
    padding: 0 15px

    canvas
      max-width: 100%
    .btn
      background: url("~assets/space/download-btn.png") center center no-repeat
      background-size: cover
      width: pxRes(91 * .9)
      height: pxRes(99 * .9)
      position: relative
      top: pxRes(-30)
      float: right
    .title
      background: url("~assets/space/title-2.png") center center no-repeat
      background-size: cover
      width: pxRes(190 * .9)
      height: pxRes(52 * .9)
      margin: 0 auto pxRes(18)
    .title.photo
      background: url("~assets/space/title-1.png") center center no-repeat
      background-size: cover
      width: pxRes(290 * .9)
      height: pxRes(58 * .9)
      margin: 0 auto pxRes(12)
  .pop
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 999
    display: flex
    align-items: center
    justify-content: center
    background: rgba(0,0,0,.42)
    .content
      background: url("~assets/space/pop.png") center center no-repeat
      background-size: cover
      width: pxRes(120 * 1.5)
      height: pxRes(130 * 1.5)
      .btn
        background: url("~assets/space/ok.png") center center no-repeat
        background-size: cover
        width: pxRes(98 * 1.5)
        height: pxRes(30 * 1.5)
        margin: pxRes(90 * 1.5) auto 0
  .space-title
    font-size: pxToRem(32)
    color: rgba(80,130,214,1);
    position: fixed;
    top: 0;
    left: pxRes(80)
    z-index: 999;
    font-family: "PingFang SC", "Microsoft YaHei UI", Helvetica;
  .blindboxicon
    background: url("~assets/space/blindbox.png") center center no-repeat
    background-size: 100% auto
    width: pxRes(42 * 1.5)
    height: pxRes(48 * 1.5)
    position: absolute
    top: pxRes(89 * 1.5)
    left: pxRes(190 * 1.5)     
    top: pxRes(62 * 1.5)
  .blindboxicon.on
    background: url("~assets/space/blindbox-on.png") center center no-repeat
    background-size:  100% auto
</style>
<style>
#download canvas{
  max-width: 100%;
}
.welcomeBox{
  position: fixed;
  z-index: 9999;
  top:0;
  left:0;
}
</style>
